export const consentIntro = (
  <div>
    <p>
      Thank you for your interest in learning more about the Schaeffler Group. We will provide the requested material to
      you in digital form - free of charge. We are also happy to inform you about future products, services, events,
      etc., from the companies of the Schaeffler Group.
    </p>
    <p>
      Please complete the required information first and click on “Submit”. Your download will then start automatically.
    </p>
    <p>
      You will then in parallel receive a confirmation email to the email address you provided. to confirm your
      registration and consent(s).
    </p>
  </div>
);
